import React from 'react';

import jet from "@randajan/jet-react";

import "./MenuLink.scss";
import { Menu } from '@randajan/jet-react/dom/menu';
import { Link } from '@randajan/jet-react/dom/link';

export const MenuLink = (props)=>{
    const menu = Menu.use();
    const actions = [menu?.blur, props.onClick];
    return <Link {...props} onClick={(ev)=>{jet.run(actions, ev)}}/>;
}


